import React from "react";
import { Row, Col } from "react-bootstrap";
import usePoolToken from "../../../hooks/usePoolToken";
import { formatPercentage } from "../../../utils/format";
import useGenericCall from "../../../hooks/useGenericCall";
import { useOffchainBorrowable } from "../../../hooks/useOffchain";
import { PoolTokenType } from "impermax-sdk";


export default function BorrowAPR({ amount }: { amount: number }) {
  const poolTokenType = usePoolToken();
  if (poolTokenType == PoolTokenType.Collateral) return null;

  const borrowAPR = useGenericCall(
    useOffchainBorrowable(), 
    offchainBorrowable => offchainBorrowable.getNextBorrowAPR(amount),
    [amount]
  );

  return (
    <Row>
      <Col xs={6}>Borrow APR:</Col>
      <Col xs={6} className="text-right">{formatPercentage(borrowAPR)}</Col>
    </Row>
  );
}